<app-side-menu>
  <div class="product-view-container">
    <!-- Header -->
    <div class="header">
      <div class="header-content">
        <div class="title-section">
          <h1><i class="fa-solid fa-eye"></i> Visualizar Produto</h1>
          <p>Detalhes completos do produto</p>
        </div>
        <div class="header-actions">
          <button class="btn-secondary" (click)="navigateBack()">
            <i class="fa-solid fa-arrow-left"></i>
            Voltar
          </button>
          <button *appHasPermission="'Products.Edit'" class="btn-primary" (click)="navigateToEdit()" [disabled]="!product">
            <i class="fa-solid fa-edit"></i>
            Editar
          </button>
        </div>
      </div>
    </div>

    <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-state">
      <i class="fa-solid fa-spinner fa-spin"></i>
      <p>Carregando produto...</p>
    </div>

    <!-- Product Details -->
    <div *ngIf="!isLoading && product" class="product-details">
      <!-- Product Header Card -->
      <div class="product-header-card">
        <div class="product-icon">
          <i class="fa-solid fa-box"></i>
        </div>
        <div class="product-info">
          <h2>{{product.name}}</h2>
          <p class="product-code">
            <i class="fa-solid fa-hashtag"></i>
            {{product.code}}
          </p>
          <div class="product-badges">
            <span class="badge" [ngClass]="getStatusBadgeClass(product.isActive)">
              {{getStatusText(product.isActive)}}
            </span>
            <span class="badge" [ngClass]="getTypeBadgeClass(product.type)">
              {{getTypeText(product.type)}}
            </span>
          </div>
        </div>
        <div class="product-price">
          <span class="price-label">Preço</span>
          <span class="price-value">{{formatPrice(product.basePrice)}}</span>
        </div>
      </div>

      <!-- Details Grid -->
      <div class="details-grid">
        <!-- Informações Básicas -->
        <div class="detail-card">
          <div class="card-header">
            <h3><i class="fa-solid fa-info-circle"></i> Informações Básicas</h3>
          </div>
          <div class="card-content">
            <div class="detail-row">
              <span class="detail-label">Nome:</span>
              <span class="detail-value">{{product.name}}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Código:</span>
              <span class="detail-value">{{product.code}}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Tipo:</span>
              <span class="detail-value">{{getTypeText(product.type)}}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Status:</span>
              <span class="detail-value">
                <span class="badge" [ngClass]="getStatusBadgeClass(product.isActive)">
                  {{getStatusText(product.isActive)}}
                </span>
              </span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Descrição:</span>
              <span class="detail-value">{{product.description}}</span>
            </div>
          </div>
        </div>

        <!-- Configurações de Preço -->
        <div class="detail-card">
          <div class="card-header">
            <h3><i class="fa-solid fa-dollar-sign"></i> Preço e Duração</h3>
          </div>
          <div class="card-content">
            <div class="detail-row">
              <span class="detail-label">Preço Base:</span>
              <span class="detail-value price-highlight">{{formatPrice(product.basePrice)}}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Ciclo de Cobrança:</span>
              <span class="detail-value">{{product.billingCycle}}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Duração:</span>
              <span class="detail-value">{{formatDays(product.days)}}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Valor da Caução:</span>
              <span class="detail-value price-highlight">{{formatPrice(product.depositAmount)}}</span>
            </div>
          </div>
        </div>

        <!-- Configurações Adicionais -->
        <div class="detail-card">
          <div class="card-header">
            <h3><i class="fa-solid fa-cog"></i> Configurações</h3>
          </div>
          <div class="card-content">
            <div class="detail-row">
              <span class="detail-label">Incluir Seguro:</span>
              <span class="detail-value">
                <i class="fa-solid" [class.fa-check]="product.includeInsurance" [class.fa-times]="!product.includeInsurance"
                   [class.text-success]="product.includeInsurance" [class.text-danger]="!product.includeInsurance"></i>
                {{product.includeInsurance ? 'Sim' : 'Não'}}
              </span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Incluir Manutenção:</span>
              <span class="detail-value">
                <i class="fa-solid" [class.fa-check]="product.includeMaintenance" [class.fa-times]="!product.includeMaintenance"
                   [class.text-success]="product.includeMaintenance" [class.text-danger]="!product.includeMaintenance"></i>
                {{product.includeMaintenance ? 'Sim' : 'Não'}}
              </span>
            </div>
          </div>
        </div>

        <!-- Configurações do Plano Realize -->
        <div class="detail-card" *ngIf="product.isPlanSale">
          <div class="card-header">
            <h3><i class="fa-solid fa-sliders"></i> Configurações do Plano</h3>
          </div>
          <div class="card-content">
            <div class="detail-row" *ngIf="product.installments != null">
              <span class="detail-label">Número de Parcelas:</span>
              <span class="detail-value">{{product.installments}}x</span>
            </div>
            <div class="detail-row" *ngIf="product.paymentBank">
              <span class="detail-label">Banco de Pagamento:</span>
              <span class="detail-value">{{product.paymentBank}}</span>
            </div>
            <div class="detail-row" *ngIf="product.maxVehicles != null">
              <span class="detail-label">Limite de Veículos:</span>
              <span class="detail-value">{{product.maxVehicles}} veículos</span>
            </div>
            <div class="detail-row" *ngIf="product.preventiveMaintenanceMonthlyLimit != null">
              <span class="detail-label">Preventivas por Mês:</span>
              <span class="detail-value">{{product.preventiveMaintenanceMonthlyLimit}}x/mês</span>
            </div>
            <div class="detail-row" *ngIf="product.penultimateInstallmentAdditional != null && product.penultimateInstallmentAdditional > 0">
              <span class="detail-label">Acréscimo na Penúltima Parcela:</span>
              <span class="detail-value price-highlight">{{formatPrice(product.penultimateInstallmentAdditional)}}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Caução Reembolsável:</span>
              <span class="detail-value">
                <i class="fa-solid" [class.fa-check]="product.isDepositRefundable" [class.fa-times]="!product.isDepositRefundable"
                   [class.text-success]="product.isDepositRefundable" [class.text-danger]="!product.isDepositRefundable"></i>
                {{product.isDepositRefundable ? 'Sim' : 'Não'}}
              </span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Suporte de Rua:</span>
              <span class="detail-value">
                <i class="fa-solid" [class.fa-check]="product.includesRoadsideSupport" [class.fa-times]="!product.includesRoadsideSupport"
                   [class.text-success]="product.includesRoadsideSupport" [class.text-danger]="!product.includesRoadsideSupport"></i>
                {{product.includesRoadsideSupport ? 'Sim' : 'Não'}}
              </span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Substituição de Veículo:</span>
              <span class="detail-value">
                <i class="fa-solid" [class.fa-check]="product.includesVehicleSubstitution" [class.fa-times]="!product.includesVehicleSubstitution"
                   [class.text-success]="product.includesVehicleSubstitution" [class.text-danger]="!product.includesVehicleSubstitution"></i>
                {{product.includesVehicleSubstitution ? 'Sim' : 'Não'}}
              </span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Veículos Exclusivos:</span>
              <span class="detail-value">
                <i class="fa-solid" [class.fa-check]="product.exclusiveVehicles" [class.fa-times]="!product.exclusiveVehicles"
                   [class.text-success]="product.exclusiveVehicles" [class.text-danger]="!product.exclusiveVehicles"></i>
                {{product.exclusiveVehicles ? 'Sim' : 'Não'}}
              </span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Requer Checklist (Preventiva):</span>
              <span class="detail-value">
                <i class="fa-solid" [class.fa-check]="product.requiresChecklist" [class.fa-times]="!product.requiresChecklist"
                   [class.text-success]="product.requiresChecklist" [class.text-danger]="!product.requiresChecklist"></i>
                {{product.requiresChecklist ? 'Sim' : 'Não'}}
              </span>
            </div>
          </div>
        </div>

        <!-- Informações do Sistema -->
        <div class="detail-card">
          <div class="card-header">
            <h3><i class="fa-solid fa-clock"></i> Informações do Sistema</h3>
          </div>
          <div class="card-content">
            <div class="detail-row">
              <span class="detail-label">Criado em:</span>
              <span class="detail-value">{{formatDate(product.createdAt || null)}}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Atualizado em:</span>
              <span class="detail-value">{{formatDate(product.updatedAt || null)}}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="action-buttons">
        <button class="btn-secondary" (click)="navigateBack()">
          <i class="fa-solid fa-arrow-left"></i>
          Voltar para Lista
        </button>
        <button class="btn-primary" (click)="navigateToEdit()">
          <i class="fa-solid fa-edit"></i>
          Editar Produto
        </button>
      </div>
    </div>

    <!-- Error State -->
    <div *ngIf="!isLoading && !product" class="error-state">
      <i class="fa-solid fa-exclamation-triangle"></i>
      <h3>Produto não encontrado</h3>
      <p>O produto solicitado não foi encontrado ou não existe.</p>
      <button class="btn-primary" (click)="navigateBack()">
        <i class="fa-solid fa-arrow-left"></i>
        Voltar para Lista
      </button>
    </div>
  </div>
</app-side-menu>
